import Tooltip from './tooltip.js'
import DTooltip from './d-tooltip.js'

Tooltip.DTooltip = DTooltip

export default Tooltip



// WEBPACK FOOTER //
// ./src/components/tooltip/index.js